<template>
    <v-dialog v-model="show" max-width="700" persistent no-click-animation>
        <div class="FSDialog">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>FreeSWITCH log</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar">
                <div v-if="items.length > 0">
                    <table class="property-table">
                        <thead>
                        <tr>
                            <th rowspan="2">{{ $f.tc('issueType') }}</th>
                            <th colspan="2">{{ $f.tc('details') }}</th>
                        </tr>
                        <tr>
                            <th>Sentence</th>
                            <th>Time (s)</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items" :key="`monitor_${index}`">
                            <td>{{ item.type }}</td>
                            <td>{{ item.details.sentence }}</td>
                            <td>{{ item.details.duration }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="fsLog" class="mt-10">
                    <div class="hide-menu">
                        <VueJsonEditor
                            v-model="fsLog"
                            mode="view"
                            class="jsoneditor-border"
                            :expanded-on-start="false"
                        ></VueJsonEditor>
                    </div>
                </div>
                <div v-else>
                    <div class="centerXY not-found-box">{{ $f.tc('notFoundFSLog') }}</div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import FormFileMixin from '@/modules/fptai/mixins/FormFileMixin'
import {mapState} from 'vuex'
import VueJsonEditor from 'vue-json-editor'

export default {
    name: 'FSDialog',
    mixins: [FormMixin, DialogMixin, FormFileMixin],
    components: {VueJsonEditor},
    computed: {
        ...mapState({
            fsLog: state => state.debug.FSLog,
            callMonitor: state => state.debug.callMonitor ? state.debug.callMonitor : {}
        }),
        headers() {
            return [
                {
                    text: this.$f.tc('issueType'),
                    value: 'type'
                },
                {
                    text: this.$f.tc('details'),
                    value: 'details',
                },
            ]
        },
        items() {
            if (Object.keys(this.callMonitor).length === 0) {
                return []
            }

            return this.parseCallMonitor()
        },
        monitorKeys() {
            return [
                {
                    "type": "fs_error",
                    "key": "fs_error",
                    "text": this.$f.tc('fsError')
                },
                {
                    "type": "dm",
                    "key": 'long_response',
                    "text": this.$f.tc('dmeSlowResponse')
                },
                {
                    "type": "tts",
                    "key": 'long_tts_duration',
                    "text": this.$f.tc('ttsSlowResponse')
                },
                {
                    "type": "asr",
                    "key": 'long_asr_duration',
                    "text": this.$f.tc('asrSlowResponse')
                },
                {
                    "type": "asr",
                    "key": 'long_record',
                    "text": this.$f.tc('asrLongRecordDuration')
                },
                {
                    "type": "tts",
                    "key": 'no_precache_sentence',
                    "text": this.$f.tc('ttsNoPreCache')
                },
            ]
        }
    },
    methods: {
        parseCallMonitor() {
            let items = []
            this.monitorKeys.forEach(item => {
                let issueData = this.callMonitor[item.type]
                if (!issueData || (item.type !== "fs_error" && !issueData[item.key])) {
                    return
                }

                if (item.key === "no_precache_sentence") {
                    issueData[item.key].forEach(i => {
                        items.push({
                            "type": item.text,
                            "details": {
                                "sentence": i
                            }
                        })
                    })
                    return
                }

                if (item.type === "fs_error") {
                    items.push({
                        "type": item.text,
                        "details": {
                            "sentence": issueData === "dm" ? "dme" : issueData
                        }
                    })
                    return
                }

                issueData[item.key].forEach(i => {
                    i.duration = i.duration / 10000
                    items.push({
                        "type": item.text,
                        "details": i
                    })
                })
            })
            return items
        }
    }
}
</script>

<style scoped lang="scss">
.FSDialog {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .label {
        margin-top: 12px;
        font-family: "open sans semi", serif;
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .text-upload {
        font-size: 14px;
        padding: 12px;
        max-height: 60vh;
        overflow-y: auto;
    }

    .hide-menu {
        ::v-deep .jsoneditor-menu {
            display: none;
        }

        min-height: 50px;
        overflow-y: auto;
    }
}


.not-found-box {
    flex: 1;
    font-family: "open sans", serif;
    font-size: 14px;
    margin: 12px;
}

.property-table {
    width: 100%;
    border: 1px solid #96add0;
    border-collapse: collapse;
    margin-top: 10px;

    thead {
        background: #e4edfa;
    }

    tbody {
        tr {
            border-bottom: 1px solid #E4EDFA;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    tr {
        height: 30px !important;
    }

    td:nth-child(1) {
        padding: 0 6px 0 12px;
    }

    td:nth-child(2) {
        padding: 4px;
    }

    td:nth-child(3) {
        padding: 0 0 0 6px;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
        padding-right: 6px;
    }

    th {
        text-align: center;
        font-size: 14px;
        border: 1px solid #96add0;
    }

    td {
        border: 1px solid #96add0;
    }
}

.jsoneditor-border {
    ::v-deep .jsoneditor  {
        border: 1px solid #96add0 !important;
    }
}

</style>
